import { render, staticRenderFns } from "./Promocion.vue?vue&type=template&id=905532fa&scoped=true&"
import script from "./Promocion.vue?vue&type=script&lang=js&"
export * from "./Promocion.vue?vue&type=script&lang=js&"
import style0 from "./Promocion.vue?vue&type=style&index=0&id=905532fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905532fa",
  null
  
)

export default component.exports